import PropTypes from 'prop-types';

export const facilityBatteryShape = PropTypes.shape({
  name: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isActive: PropTypes.bool,
});
